/* eslint-disable prefer-destructuring */
var breakpoints = ["48em", "64em", "80em"];
breakpoints.sm = breakpoints[0];
breakpoints.md = breakpoints[1];
breakpoints.lg = breakpoints[2];
export { breakpoints as default };